
import { FC } from "react";
import { AuthenticatedLayout } from "../../../layouts";
import { T4SlipSetup } from "../../../components/T4Slip";

export interface IT4SlipSetupPage {}

export const T4SlipSetupPage: FC<IT4SlipSetupPage> = () => {
  return (
    <AuthenticatedLayout
      pageTitle="Create T4 Slip"
      breadcrumbCurrentPageName=""
      breadcrumbLinks={[
        // { text: "Compliance", navigateTo: "/compliance/t4/list" },
        // { text: "T4", navigateTo: "/compliance/t4/list" },
        // { text: "Create T4 Slip", navigateTo: "/compliance/t4/setup" },
      ]}
      mainContents={<T4SlipSetup testId="t4-slip-setup" />}
    />
  );
};
